<!--
 * @Author: MX
 * @Date: 2020-08-03 11:36:59
 * @LastEditTime: 2023-10-16 09:35:10
 * @Description: 服务管理 - 快件跟踪
-->
<template>
  <div class="expressTracking main-wrap">
    <div class="track-left">
      <base-input-tag ref="inputTag" :placeholder="$lang('多单号用英文逗号或回车隔开，单次最多可输入100个运单号')" v-model="searchKey" :validate="inputTagValid" :addTagOnBlur="true" maxHeight="360px"
                      class="cms-input-tag"></base-input-tag>
      <div class="track-left-btns">
        <el-button type="primary" class="b_reset h32" plain @click="resetSearch">{{ $lang('清空') }}</el-button>
        <el-button type="primary" class="h32" :loading="keyBtn" @click="searchFun">{{ $lang('立即查询') }}</el-button>
      </div>
    </div>
    <div class="track-right">
      <el-collapse v-model="activeName" v-if="traceList.length > 0">
        <el-collapse-item v-for="(tag, $index) in traceList" :key="tag.id" :title="$lang('运单编号')+'：' + tag.keyword" :name="$index">
          <!-- <div class="track-right_item" v-if="tag.details&&tag.details.length > 0">
                <el-steps direction="vertical" class="track-right_item_steps">
                    <el-step v-for="(item, index) in tag.details"
                            :key="index"
                            :title="item.scanTime"
                            :class="[index === 0 ? 'isFirst':'']"
                            :description="item.customerTracking">
                            <img v-if="item.statusCode === 2" src="../../assets/images/tra-black-take.png" alt="" slot="icon">
                             <template slot="icon">
                                <span class="track-right_item_status"> {{item.status}}</span>
                            </template>
                            </el-step>
                </el-steps>
          </div> -->
          <div class="track-right_item" v-if="tag.details&&tag.details.length > 0">
            <!-- <div>
              <p class="step-content" v-for="(item, index) in tag.details" :class="{ waybillFont: index === 0 }" :key="index">{{ item.scanTime }}</p>
            </div> -->
            <div class="track-right_item_steps">
              <el-steps direction="vertical" :active="tag.details.length" id="item_steps">
                <el-step v-for="(item, index) in tag.details" :key="index" :class="[index === 0 ? 'isFirst':'', item.statusCode === 2 && 'dashed-line']">
                  <div class="steps-title" :class="{ waybillFont: index === 0 }" slot="title">
                    {{item.scanTime}}
                  </div>
                  <img v-if="item.statusCode === 2" :src="index === 0 ? traBlackTake : traGreyTake" alt="" slot="icon">
                  <img v-else-if="item.statusCode === 3" :src="index === 0 ? traBlackTake : traGreyTake" alt="" slot="icon">
                  <img v-else-if="item.statusCode === 4" :src="index === 0 ? traBlackLanding : traGreyLanding" alt="" slot="icon">
                  <i style="font-size:20px" v-else :style="{color: index === 0 ? '#E60000' : '#ddd'}" class="iconfont icon-pc_kuaijiangenzong_gaoliang" slot="icon"></i>
                  <div class="track-box" slot="description">
                    <div class="item-status" :class="{ waybillFont: index === 0 }">
                      {{ item.status }}
                    </div>
                    <div style="width:100%; margin-left: 50px;">
                      <p class="step-content">
                        <span class="text" :class="{ 'waybillFont': index === 0 }" v-html="item.customerTracking"></span>
                        <span class="img-btn" @click="handleImageView(item)" v-if="(item.statusCode === 6 && item.typePiceUrl) || item.arrivalPicUrl">{{ $t('查看图片') }}</span>
                      </p>
                    </div>
                  </div>
                </el-step>
              </el-steps>
            </div>
          </div>
          <div v-else class="no-data">
            {{ $lang('暂无数据') }}
          </div>
          <div v-if="tag.hasImg" class="show-pic" @click="preViewImg(tag)">{{ $lang('查看签收图片') }}</div>
        </el-collapse-item>
      </el-collapse>
    </div>

    <el-dialog
      :title="$lang('预览图片')"
      :visible.sync="dialogVisible"
      width="80%"
      height="80%">
      <el-carousel height="80vh" :autoplay="false" :interval="5000" arrow="always" indicator-position="none">
        <el-carousel-item v-for="item in srcList" :key="item">
          <img style="max-width: 100%" :src="item" alt="">
        </el-carousel-item>
      </el-carousel>
    </el-dialog>
  </div>
</template>

<script>
const traBlackTake = require('../../assets/images/tra-black-take.png')
const traGreyTake = require('../../assets/images/tra-grey-take.png')
const traGreyLanding = require('../../assets/images/tra-grey-landing.png')
const traBlackLanding = require('../../assets/images/tra-black-landing.png')
import { fetchOSS, getDetailByWaybillNos, getImgList } from '@/api/module/customer'
import { RESPONSE_SUCCESS } from '@constants'

export default {
  name: 'ExpressTracking',
  data() {
    return {
      traBlackTake, // 黑色下降
      traGreyTake, // 灰色下降
      traBlackLanding, // 黑色起飞
      traGreyLanding, // 灰色起飞
      isShowFirst: false,
      searchKey: [],
      searchKeyOld: [],
      traceList: [], // 物流跟踪list
      inputTagValid: '',
      orderIds: '',
      preViewVisible: false,
      keyBtn: false,
      activeName: 0,
      dialogVisible: false,
      hasImg: false,
      srcList: [],
      itemData: {},
    }
  },
  mounted() {
    this.orderIds = this.$route.params.orderIds
    if (this.orderIds) {
      this.searchKey = this.orderIds.split(',')
      this.searchKeyOld = this.orderIds.split(',')
      this.searchFun()
    }
    const waybillId = this.$route.query.waybillId
    if (waybillId) {
      this.searchKey = waybillId.split(',')
      this.searchFun()
    }
  },
  activated() {
    const waybillId = this.$route.query.waybillId
    if (waybillId) {
      this.searchKey = waybillId.split(',')
      this.searchFun()
    }
  },
  watch: {},
  methods: {
    /**
     * 查看图片
     * @param strUrl
     * @returns {Promise<void>}
     */
    async handleImageView(item) {
      let typePiceUrlArr = []
      let arrivalPicUrlArr = []
      let urls = []
      if (item.typePiceUrl) {
        typePiceUrlArr = item.typePiceUrl.split(',')
      }
      if (item.arrivalPicUrl) {
        arrivalPicUrlArr = item.arrivalPicUrl.split(',')
      }
      urls = [...typePiceUrlArr, ...arrivalPicUrlArr]
      if (urls.length > 0) {
        try {
          const { code, data, msg } = await fetchOSS([...urls])
          if (code === 1) {
            this.dialogVisible = true
            this.srcList = data
          } else {
            this.$message.error(msg)
          }
        } catch (e) {
          this.$message.error(e)
        }
      } else {
        this.$message.error(this.$lang('数据错误'))
      }
    },
    // 重置搜索
    resetSearch() {
      this.searchKey = []
      this.searchKeyOld = []
      this.traceList = []
      this.$refs.inputTag.newTag = ''
      if (this.orderIds) this.$router.push({ path: `/redirect/expressTracking` })
    },
    clearData() {
      this.traceList = []
    },
    // 搜索
    searchFun() {
      const reqList = []
      if (!this.searchKey || this.searchKey.length === 0) return this.$message.warning(this.$lang('请输入单号'))
      if (this.searchKey.length > 100) return this.$message.warning(this.$lang('您查询的单号已超出100条'))
      //   const newArr = this.searchKey.filter(item => !this.searchKeyOld.some(ele => ele === item))// 单次只能查询10条数据
      //   if (newArr.length > 10) return this.$message.warning(this.$lang('单次只能查询10条数据'))
      //   this.searchKeyOld = this.searchKey.slice(0)
      this.searchKey.forEach(item => reqList.push(item))
      this.getOrderList(reqList)
    },
    // 查询单号
    async getOrderList(reqList) {
      // const params = { keywordList: reqList }
      this.keyBtn = true
      const { code, msg, data } = await getDetailByWaybillNos(reqList)
      this.keyBtn = false
      if (code !== RESPONSE_SUCCESS) return this.$message.warning(this.$lang(msg))
      if (data && data.length) {
        this.traceList = data.map(item => {
          const i = item.details[0]
          if (i && i.code === 100 && i.remark2 === '1') {
            item.hasImg = true
          } else {
            item.hasImg = false
          }
          return item
        })
      } else {
        this.hasImg = false
      }
    },
    // 手机号加*
    disposePhoneFun(num) {
      let start = ''
      let end = ''
      if (num) {
        start = num.toString().substring(0, 3)
        end = num.toString().substring(num.length - 4, num.length)
      }
      return start + '****' + end
    },
    // 查看图片
    preViewImg(item) {
      const itemData = item.details[0]
      if (!itemData) return
      getImgList(
        {
          waybillNo: itemData.billCode,
          scanTime: itemData.scanTime,
          scanByCode: itemData.scanByCode,
          imgType: 2,
        }
      ).then(res => {
        if (res && res.succ) {
          this.dialogVisible = true
          this.srcList = res.data
        } else {
          this.srcList = []
          this.$message.error(this.$lang(res.msg))
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.expressTracking {
  width: 100%;
  display: flex;
  flex-direction: row;

  .track-left {
    width: 390px;
    padding: 24px;
    box-sizing: border-box;

    .track-left-btns {
      float: right;
      margin-top: 16px;
    }
  }

  .b_reset {
    width: 88px;
  }

  .track-right_item_steps {
    margin-left: 180px;
    .steps-title {
      position: absolute;
      top: 4px;
      left: -182px;
      color: #2b2b2b !important;
    }
  }

  .waybillFont {
    font-weight: 600 !important;
    color: #2b2b2b !important;
    line-height: 16px !important;
  }
  .track-box {
    display: flex;
    padding-left: 50px;
    flex: 1;
  }

  .item-status {
    width: 150px;
    // margin: 0 30px;
    opacity: 1;
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: left;
    color: #666666;
    line-height: 20px;
  }
  .track-right {
    flex: 1;
    border: 16px solid #EDEEF3;
    padding: 16px 24px;
    background: #fff;
    overflow: auto;

    .no-data {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .track-right_item {
      //  margin-left: 60px;
      display: flex;
      p {
        margin: 0;
      }

      // padding-top: 30px 30px 0 30px !important;
      div {
        // float: left;
        // flex: 1;
        // // width: 100%;
        height: 100%;
        // padding-right: 20px;

        .step-content {
          display: flex;
          margin-bottom: 20px;
          opacity: 1;
          font-size: 14px;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          text-align: left;
          color: #666666;
          line-height: 20px;
          // display: flex;
          // align-items: flex-start;
          // justify-content: space-between;

          .text {
            display: flex;
            flex: 1;
            // position: relative;
            // .step-content-status {
            //   width: 150px;
            // }
          }

          .img-btn {
            color: #f00;
            cursor: pointer;
            user-select: none;
            margin-left: 30px;
            line-height: 20px;
          }
        }
      }
    }

    .track-right_item_status {
      position: absolute;
      top: -9px;
      right: 0px;
      line-height: 24px;
      width: 75px;
    }
  }

}
</style>
<style lang="scss">
.expressTracking {
  .input-tag-container {
    float: left;
    width: 100% !important;
    height: 160px;

    .vue-input-tag-wrapper {
      height: 160px !important;
      box-sizing: border-box;
    }
  }

  .el-collapse {
    border-bottom: 0;
    border-top-color: transparent !important;

    .el-collapse-item {
      background: #F7F7F9;
      border: 1px solid #EEEEEE;
      border-radius: 8px;
      margin-bottom: 24px;
      padding: 5px 24px;

      .el-collapse-item__header {
        background: #F7F7F9;
        font-weight: 600;
        justify-content: flex-start;
        font-size: 16px;
        padding-bottom: 0;
        border: 0;

        &.is-active {
          color: $--color-primary;
        }
      }

      .el-collapse-item__wrap {
        background: #F7F7F9;
        border: 0;
      }

      .el-collapse-item__arrow {
        margin-left: 16px;
      }
    }
  }

  .el-step {
    position: relative;

    .el-step__head {
      display: flex;
      // justify-content: center;
      width: auto !important;
    }

    .el-step__icon {
      width: 4px;
      height: 4px;
      border-radius: 50%;
      border: 0;
      background: #DDDDDD;
      position: relative;
      margin-top: 9px;
      font-size: 13px;
    }

    .el-step__description {
      margin-bottom: 12px;
      padding-right: 0;
    }

    .el-step__line {
      top: 20px;
      left: 1px;
    }

    img {
      width: 25px;
      height: 25px;
    }

    &.isFirst {
      .track-right_item_status, .el-step__title, .el-step__description {
        color: #333333;
      }

      .el-step__icon {
        width: 8px;
        height: 8px;
        background: #51c419;
        margin-left: -2px;
      }

      .track-right_item_status {
        font-weight: bold;
      }
    }

    .el-step__line-inner {
      border: 1px dashed #C0C4CC;
    }

    &.dashed-line {
      .is-finish {
        border-right: 2px dashed #C0C4CC;
        margin-left: -3px;
      }

      img {
        background: #F7F7F9;
      }

      .el-step__line, .el-step__main {
        display: none;
      }
    }
  }
  .el-carousel__container {
    height: 80vh;

    .el-carousel__item {
      padding: 0 10px;
      text-align: center;

      img {
        max-width: 100%;
        height: 100%;
      }
    }
  }
}

.show-pic {
  color: #e60012;
  font-size: 14px;
  cursor: pointer;
}
</style>

